import {createRoot, hydrateRoot} from 'react-dom/client';
import GetInvolved from '../pages/GetInvolved/GetInvolved'
import "../index.css";
import "../pages/GetInvolved/GetInvolved.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<GetInvolved {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <GetInvolved {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).GetInvolvedVC = {mount, hydrate, unmount}